import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: CheckboxComponent }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input()
  isLock: boolean = false;

  @Input()
  get checked(): boolean {
    return this._checked;
  }

  set checked(value: boolean) {
    if (value != this.checked) {
      this._checked = value;
      this.cdr.markForCheck();
    }
  }

  private _checked: boolean = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) { }

  onChange = (checked: boolean) => { };

  onTouched = () => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }

  toggle(): void {
    if (!this.isLock) {
      this.checked = !this.checked;
      this.onChange(this.checked);
      this.onTouched();
      this.checkedChange.emit(this.checked);
    }
  }
}
